/*
 * @Description  :
 * @Version      : 1.0.0
 * @Author       : Luoye
 * @Date         : 2022-08-03 15:25:51
 * @LastEditors  : Luoye
 * @FilePath     : /namibox_client_web/src/views/member-subscription.ReactPage/index.tsx
 * Copyright (C) 2022 rose. All rights reserved.
 */
import ReactDOM from 'react-dom';
import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reudcer from './store/reducer';
import App from './App';
import './assets/styles/reset.scss';

const store = createStore(reudcer);
const ele = document.getElementById('root');
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  ele
);
